module.exports = __webpack_public_path__ + "static/media/twitter-dark.49a597e2.svg";